// extracted by mini-css-extract-plugin
export var button = "Button-module--button--1RGO-";
export var primary = "Button-module--primary--3iIsA";